import * as React from 'react';
const h = React.createElement;

export interface LayoutChildProps extends React.HTMLAttributes<HTMLElement> {
  children?: React.ReactNode;
  className?: string;
}

export interface SiderProps extends LayoutChildProps {
  width?: number | string;
}

const LayoutBase: React.FC<LayoutChildProps> = function Layout(props) {
  const { children, className = '', ...rest } = props;
  return h('div', { className: `min-h-screen bg-dark-950 ${className}`, ...rest }, children);
};

const Header: React.FC<LayoutChildProps> = function Header(props) {
  const { children, className = '', ...rest } = props;
  return h(
    'header',
    { className: `bg-dark-900 border-b border-dark-700 px-4 ${className}`, ...rest },
    children,
  );
};

const Content: React.FC<LayoutChildProps> = function Content(props) {
  const { children, className = '', ...rest } = props;
  return h('main', { className: `flex-1 ${className}`, ...rest }, children);
};

const Sider: React.FC<SiderProps> = function Sider(props) {
  const { children, width = 200, className = '', ...rest } = props;
  return h(
    'aside',
    {
      className: `bg-dark-900 border-r border-dark-700 flex-shrink-0 overflow-y-auto ${className}`,
      style: { width },
      ...rest,
    },
    children,
  );
};

type LayoutType = React.FC<LayoutChildProps> & {
  Header: typeof Header;
  Content: typeof Content;
  Sider: typeof Sider;
};

const Layout = LayoutBase as LayoutType;
Layout.Header = Header;
Layout.Content = Content;
Layout.Sider = Sider;

export { Layout };
